const styles = {
  fields: {
    display: 'grid',
    gridTemplateRows: 'auto',
    gridRowGap: theme => theme.spacing(2),
  },
  alert: {
    mt: 2,
    mb: 2.75,
    '& .MuiAlert-message .MuiLink-root': {
      fontSize: 'inherit',
      fontWeight: '700',
      lineHeight: 'inherit',
      margin: 0,
    },
  },
  alertWrapper: {
    mt: 4,
  },
  submitButton: { mt: 2 },
  circularProgress: { color: 'neutral.white' },
  rememberPasswordWrapper: { mt: 2, display: 'flex', justifyContent: 'center' },
}

export default styles
